<script lang="ts">

    import type {Community} from "../models/model";
    import {Utils} from "../util";
    import {createEventDispatcher} from 'svelte'

    const dispatch = createEventDispatcher()

    export let item: Community;

    export let selected: boolean = false;

    function handleClick(event: any) {

        // event.stopPropagation(); // Prevent event from bubbling to the parent

        // setTimeout(() => {
        //     console.log("handleClick!");
        //
        //     dispatch("itemClick", item);
        // }, 100)

//        console.log("handleClick!");

        dispatch("itemClick", item);

    }

</script>


<div class="result-item" class:selected={selected} on:click={handleClick}>
    {Utils.chooseTranslation(item.name)}
</div>

<style lang="scss">

  .result-item {
    font-size: 20px;
    padding: 10px 2rem;
    color: #000000;

    &:hover {
      background: #054055;
      color: white;
      cursor: pointer;
    }

    &.selected {
      background: #054055;
      color: white;
    }

  }

</style>
